import React, { useCallback, useMemo } from 'react';
import ArticleCreationDialog from './ArticleCreationDialog'
import SelectInput from './SelectInput';
import { Account, Article, CostCenterItem, ProjectWithArticles } from './Types';
import { useHasCapability } from './Capabilities';

export function isValidArticle(articleId: string | null) {
  return articleId !== null && articleId != ''
}

const valueGetter = (article: Article) => article.article_id
const nameGetter = (article: Article) => article.Name
const emptyArray: Article[] = []

function ArticleSelect({project, officialIncomeAccounts, value, onChange, required, ...props}:
  {
    project: ProjectWithArticles | null,
    officialIncomeAccounts: Account[],
    value: string | null,
    onChange: (newValue: string, newCostCenterItems?: CostCenterItem<ProjectWithArticles>[]) => void,
    required: boolean,
    disabled: boolean,
    label?: string
  }) {
  // Only offer "create new article" to roles that hold article.create; others just pick
  // from existing articles (the backend also gates POST /incomes/articles).
  const canCreateArticle = useHasCapability('article.create')
  const CreationDialog = useMemo(
    () =>
    project !== null && canCreateArticle ?
    (({onCreate, onCancel}: {
      onCreate: ({newArticleId, newCostCenterItems}: {newArticleId: string, newCostCenterItems: CostCenterItem<ProjectWithArticles>[]}) => void,
      onCancel: () => void}
    ) =>
      ArticleCreationDialog({
        onCreate: onCreate,
        onCancel: onCancel,
        project: project,
        officialIncomeAccounts: officialIncomeAccounts
      })) : null,
    [project, officialIncomeAccounts, canCreateArticle]
  )

  const handleCreate = useCallback(
    ({newArticleId, newCostCenterItems}:
      {
        newArticleId: string,
        newCostCenterItems: CostCenterItem<ProjectWithArticles>[]
      }) => { onChange(newArticleId, newCostCenterItems) },
    [onChange]
  )

  return (
    <SelectInput
      options={project ? project.articles : emptyArray}
      valueGetter={valueGetter}
      nameGetter={nameGetter}
      value={value}
      onChange={onChange}
      onCreate={handleCreate}
      required={required}
      CreationDialog={CreationDialog}
      {...props}
    />
   )

}


export default ArticleSelect
